import { CognitoIdentityCredentialProvider, fromCognitoIdentityPool } from '@aws-sdk/credential-providers'
import { SecretsManagerClient } from '@aws-sdk/client-secrets-manager'
import { CloudWatchClient } from '@aws-sdk/client-cloudwatch'
import { STSClient, Credentials } from '@aws-sdk/client-sts'
import { APIGatewayClient } from '@aws-sdk/client-api-gateway'
import { LOCAL_STORAGE } from '../services/LocalStorage'
import { SessionKey } from '../constants/SessionKey'
import { APP_CONFIG } from '../config/AppConfig'
import { SESClient } from '@aws-sdk/client-ses'
import { Regions } from '../constants/Regions'
import { S3Client } from '@aws-sdk/client-s3'

const IDENTITY_POOL_ID = APP_CONFIG.getCognitoIdentityPoolId()
const COGNITO_IDP = APP_CONFIG.getCognitoIdentityProviderId()
const REGION = APP_CONFIG.getRegion()

const clients = {s3: null as S3Client | null}

function identityToken(): string {
  return LOCAL_STORAGE.getOrDefault(SessionKey.IDENTITY_TOKEN, '') as string
}

export class ClientFactory {
  private static instance: ClientFactory

  static getInstance() {
    if (!this.instance) {
      this.instance = new this()
    }

    return this.instance
  }

  //
  // IAD region
  //

  getS3Client(): S3Client {
    if (!clients.s3) {
      clients.s3 = new S3Client({
        credentials: this.getCredentialsFromCognito(),
        region: REGION,
      })
    }

    return clients['s3'] as S3Client
  }

  getCloudWatchClient(): CloudWatchClient {
    return new CloudWatchClient({
      credentials: this.getCredentialsFromCognito(),
      region: REGION,
    })
  }

  getSecretsManagerClient(): SecretsManagerClient {
    return new SecretsManagerClient({
      credentials: this.getCredentialsFromCognito(),
      region: REGION,
    })
  }

  getAPIGatewayClient(): APIGatewayClient {
    return new APIGatewayClient({
      credentials: this.getCredentialsFromCognito(),
      region: REGION,
    })
  }

  //
  // PDX Region
  //

  getSTSClient(): STSClient {
    return new STSClient({
      credentials: this.getCredentialsFromCognito(),
      region: Regions.PDX_REGION,
    })
  }

  getSESClient(credentials: Credentials): SESClient {
    return new SESClient({
      credentials: {
        accessKeyId: credentials.AccessKeyId!,
        secretAccessKey: credentials.SecretAccessKey!,
        sessionToken: credentials.SessionToken!,
        expiration: credentials.Expiration!
      },
      region: Regions.PDX_REGION,
    })
  }

  private getCredentialsFromCognito(): CognitoIdentityCredentialProvider {
    return fromCognitoIdentityPool({
      clientConfig: { region: REGION },
      identityPoolId: IDENTITY_POOL_ID,
      logins: {
        [COGNITO_IDP]: identityToken()
      }
    })
  }
}

export default ClientFactory

export const CLIENT_FACTORY = ClientFactory.getInstance()
